<div class="page-content bg-white">
  <!-- inner page banner -->
  <!-- <div class="dez-bnr-inr overlay-black-middle" style="background-image:url('/assets/images/bg4.jpg');">
    <div class="container">
      <div class="dez-bnr-inr-entry">
        <h1 class="text-white">Contáctenos</h1>
      </div>
    </div>
  </div> -->
  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <div class="breadcrumb-row">
    <div class="container">
      <ul class="list-inline">
        <li><a href="#">Inicio</a></li>
        <li>Contáctenos</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumb row END -->
  <!-- contact area -->
  <div class="content-area">
    <!-- Career -->
    <div class="container">
      <div class="row">
        <!-- Left part start -->
        <div class="col-md-9 m-b30">
          <h1 class="m-b20 m-t0">Contáctenos</h1>
          <div class="dez-separator bg-primary"></div>
          <div id="Stellar_video_player"></div>
        </div>
        <!-- Left part start END -->
        <div class="col-md-7">
          <div class="widget bg-white recent-posts-entry">
            <div class="widget-post-bx">
              <agm-map style="height: 300px;" [latitude]="lat" [longitude]="lng" [zoom]="zoom">
                <agm-marker [latitude]="lat" [longitude]="lng" iconUrl="/assets/marker1.png">
                  <agm-snazzy-info-window [maxWidth]="200" [closeWhenOthersOpen]="true" [isOpen]="true">
                    <ng-template>
                      Ministerio de Planificación del Desarrollo <br>
                      Av. Mariscal Santa Cruz N° 1092
                    </ng-template>
                  </agm-snazzy-info-window>
                </agm-marker>
              </agm-map>
            </div>
          </div>
        </div>
        <!-- Right part start -->
        <div class="col-md-5">
          <div>
            <h5><i class="icon-phone"></i>Central Piloto: <br><small>(591) 50850019</small></h5>
            <h5><i class="icon-phone"></i>Fax: <br><small>(591-2) 2312641</small></h5>
            <h5><i class="icon-mail"></i>E-mail: <br><small>contactanos@planificacion.gob.bo</small></h5>
            <h5><i class="icon-map2"></i>Dirección: <br><small>Av. Mariscal Santa Cruz N° 1092 Casilla N° 12814</small>
            </h5>
          </div>
        </div>
        <!-- Right part start END -->
      </div>
    </div>
    <!-- Career END -->
  </div>
  <!-- contact area END -->
</div>



// WEBPACK FOOTER //
// ./src/app/layouts/contacto/contacto.component.html